<template>
    <div id="app">
        <router-view name="header"/>
        <div class="container">
            <router-view/>
        </div>
        <router-view name="footer"/>
    </div>
</template>
<script>
  export default {}
</script>

<style lang="scss" scoped>
    @import "~@/assets/sass/now-ui-kit/variables";

    .container {
        background-color: $white-bg;
        padding-top: 80px;
    }

    #app {
        background-color: $white-bg;
    }

</style>

